var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChronometer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.112,
    height: 19.429,
    viewBox: "0 0 15.112 19.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chronometer",
    d: "M16.135,16.373V13.135a1.079,1.079,0,1,0-2.159,0v4.318a1.079,1.079,0,0,0,1.079,1.079h3.238a1.079,1.079,0,0,0,0-2.159Zm-1.079,7.556a6.476,6.476,0,1,1,6.476-6.476A6.476,6.476,0,0,1,15.055,23.929Zm3.16-14.514a8.661,8.661,0,0,0-6.321,0A2.7,2.7,0,0,1,13.436,4.5h3.238a2.7,2.7,0,0,1,1.541,4.914Zm-4.78-2.756a.54.54,0,1,0,0,1.079h3.238a.54.54,0,1,0,0-1.079Zm5.995,3.348a1.619,1.619,0,1,1,2.242,1.9,8.677,8.677,0,0,0-2.242-1.9Zm-10.994,1.9a1.619,1.619,0,1,1,2.242-1.9,8.677,8.677,0,0,0-2.241,1.9Z",
    transform: "translate(-7.499 -4.5)",
    fill: "#5f9e16"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChronometer);
export default __webpack_public_path__ + "static/media/Chronometer.9c610de5268b63614648650679c3785c.svg";
export { ForwardRef as ReactComponent };